// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProBadge":"bcu_a bha_qn bha_qo bha_ua bha_cy bha_ty bha_go bha_ka"};